import vmConfig from './vmConfig/index.vue';
import eipConfig from './eipConfig/index.vue';
import Spinner from 'kpc/components/spinner';
import {mapState} from "vuex";


let doCalcCounter = 0;

export default {
    components: {
        vmConfig,
        eipConfig,
        Spinner
    },
    props: {
        regionKey: {
            type: String,
            default: 'cn-beijing-6'
        }
    },
    computed: {
        ...mapState({
            pcommon: state => state.__pbc__.common,
            // billTypeMap: state => state.__pbc__.common.billTypeMap
        }),
    },
    data() {
        return {
            // 初始region
            curRegion: this.regionKey, //'cn-beijing-6',
            limitNum: 50,

            // 购买数量
            kecCount: 1,

            // 主机和eip的配置
            kvmData: null,
            eipData: null,

        }
    },
    created() {},
    mounted() {
        // 初始化组件
        this.$refs.vmConfig.setInitData({
            // regionKey: this.regionKey,
            isShow: true,
            userCurrency: '￥'
        });
        this.$refs.eipConfig.setInitData({
            // regionKey: this.regionKey,
            isShow: true,
            showBwsSelect: false,
            userCurrency: '￥'
        });
    },

    methods: {
        regionChange(v) {
            this.curRegion = v;
            // console.log(v, 1111)
            // doCalcCounter = 2;
            // this.$refs.vmConfig.setInitData({
            //     isShow: true,
            //     regionKey: v
            // })
            // this.$refs.eipConfig.setInitData({
            //     isShow: true,
            //     regionKey: v
            // })
        },
        output() {
            this.$emit('input', {
                kvm: this.formatKvmData(),
                eip: this.formatEipData(),
            })
        },
        changeParamEip(data) {
            this.$emit('change:param:eip', {
                eip: this.formatEipData(data),
            });
        },
        changeParamKvm(data) {
            this.$emit('change:param:kvm', {
                kvm: this.formatKvmData(data)
            });
        },
        formatKvmData(data) {
            let me = this;
            let param = data || this.kvmData;
            if (!param) {
                return null;
            }
            let detail = {
                price: param.priceData,
                region: me.pcommon.regionMap(param.mock.regionKey),
                az: me.pcommon.azMap[param.mock.azCode],
                billTypeId: param.mock.billType,
                billType: me.pcommon.billTypeMap(param.mock.billType),
                duration: param.kvm.duration,
                durationUnit: param.mock.billType == 1 ? '' : this.$refs.vmConfig.getDurationUnit(param.kvm.billType), //param.mock.billType == 1 ? '' : param.kvm.durationUnit,
                num: param.kvm.count,
                productName: param.mock.productName,
                cpu: param.mock.cpu,
                mem: param.mock.mem,
                gpu: param.kvm.gpu,
                image: _.get(param, 'mock.imageObj.title'),
                systemDiskTitle: _.get(param, 'mock.sysDiskObj.title'),
                systemDiskSize: param.mock.rootDisk,
                localDataDiskType: _.get(param, 'mock.diskObj.title'),
                localDataDiskNum: _.get(param, 'mock.diskNum'),
                localDataDiskSize: _.get(param, 'mock.diskSize'),
                ebsDataDisks: (()=>{
                    let arr = [];
                    _.forEach(param.mock.ebsDiskObjs, (d, i) => {
                        arr.push({
                            title: d.title,
                            size: param.mock.ebsDiskSizeList[i]
                        })
                    });
                    return arr;
                })()
            };
            return detail;
        },
        formatEipData(data) {
            let param = data || this.eipData;
            let me = this;
            if (!param) {
                return null;
            }
            // 价格计算器显示用
            let detail = {
                price: param.eipPrice,
                billTypeId: param.eipData.billType,
                billType: this.pcommon.billTypeMap(param.eipData.billType),
                bandwidth: param.eipData.bandwidth,//this.bandwidth,
                provider: param.eipData.provider,
                lineName: _.get(param, 'eipData.lineTypeObj.LineName'),
                duration: param.eipData.time,
                durationUnit: param.eipData.billType == 1 ? '' : this.$refs.eipConfig.getDurationUnit(param.eipData.billType), //param.eipData.billType == 1 ? '' : param.eipData.durationUnit,
                num: param.eipData.buyNum,
            }
            return detail;
        },
    },

    watch: {
        regionKey() {
            consoel.log(this.regionKey, 23)
            this.curRegion = this.regionKey || 'cn-beijing-6'
            //     {
            //     prod: 'cn-beijing-6',
            //     dev: 'cn-shanghai-2'
            // }[this.env] || 'cn-beijing-6';
        },
        // regionKey() {
        //     // console.log(this.regionKey, 123)
        // },
        // 创建数量变化了，需要同步给组件
        kecCount(v) {
            doCalcCounter = 2;
            this.$refs.vmConfig.setValue('kecCount', v);
            // this.$refs.vmConfig.calcuPrice();
            // this.$refs.eipConfig.setValue('buyNum', v);
            // this.$refs.eipConfig.calcuPrice();
        },
        // 主机配置变化和价格变化
        kvmData(val) {
            if (doCalcCounter !== 0) {
                doCalcCounter -=1;
            }
            if (doCalcCounter === 0) {
                this.output();
            }
            // this.output();
        },
        // EIP配置变化和价格变化
        eipData(val) {
            if (doCalcCounter !== 0) {
                doCalcCounter -=1;
            }
            if (doCalcCounter === 0) {
                this.output();
            }
            // this.output();
        },
    }
}
